/* eslint-disable react-hooks/exhaustive-deps */

import { firebaseConfiguration } from '@/config/analytics'
import '@/config/branchio'
import '@/config/mixpanel'

import { useAppDispatch, useAppSelector } from '@/hooks/useRedux'

import {
  setBanner,
  setInitialMatchesSkippedBeforeFirstAd,
  setIsGoogleAdsRollout,
  setMatchHistoryAdRateMobile,
  setPlayerSearchAdRateMobile,
} from '@/pages/home/appSlice'
import { userSelector } from '@/pages/user/selectors'

import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/remote-config'
import { fetchAndActivate, getValue } from 'firebase/remote-config'
import { useEffect } from 'react'

const remoteConfig = firebaseConfiguration

export function useSetBanner() {
  const { user } = useAppSelector(userSelector)
  const dispatch = useAppDispatch()
  useEffect(() => {
    fetchAndActivate(remoteConfig).then(() => {
      try {
        const webBanner = getValue(remoteConfig, 'webBanner').asString()
        const showGoogleAds = getValue(remoteConfig, 'isGoogleAdsRollout').asBoolean()
        const playerSearchAdRateMobile = getValue(remoteConfig, 'playerSearchAdRateMobile').asNumber()
        const matchHistoryAdRateMobile = getValue(remoteConfig, 'matchHistoryAdRateMobile').asNumber()
        const initialMatchesSkippedBeforeFirstAd = getValue(
          remoteConfig,
          'initialMatchesSkippedBeforeFirstAd'
        ).asNumber()

        const showAdsWhiteList = JSON.parse(getValue(remoteConfig, 'whitelist').asString())['adsEnabled']

        const webBannerData = JSON.parse(webBanner)

        const randomIndex = Math.floor(Math.random() * webBannerData?.advertisements.length)

        if (webBannerData?.showBanner) dispatch(setBanner(webBannerData?.advertisements?.[randomIndex]))

        dispatch(setIsGoogleAdsRollout(showGoogleAds || showAdsWhiteList.includes(user?.id) ? true : false))

        dispatch(setPlayerSearchAdRateMobile(playerSearchAdRateMobile || 6))

        dispatch(setMatchHistoryAdRateMobile(matchHistoryAdRateMobile || 6))

        dispatch(setInitialMatchesSkippedBeforeFirstAd(initialMatchesSkippedBeforeFirstAd || 2))
      } catch (e: any) {
        dispatch(
          setBanner({
            link: 'https://www.oofos.com/collections/dupr-pickleball-picks',
            imageUrl: '/img/Ad.png',
            message: '',
          })
        )
        console.error('Error dispatching remote configs', e)
      }
    })
  }, [])
}
